
import { DexAssessmentData } from "@/domain/entities/DexAssessment";
import { Options, prop, Vue } from "vue-class-component";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import AIAssessmentBanner from "./ai-assessment-banner.vue";

class Props {
  data = prop<any>({
    default: new DexAssessmentData()
  });
  shouldShowAIBanner = prop<boolean>({
    default: false,
    type: Boolean
  });
}
@Options({
  components: {
    AIAssessmentBanner
  }
})
export default class DEXTicketInformationSection extends Vue.with(Props) {
  formatDate(date: string): string {
    return date ? formatDate(date) : "";
  }

  statusDisputePartner(status: string) {
    let text = { label: "", title: "" };
    switch (status.toLowerCase()) {
      case "accepted":
      case "approved":
        text = {
          label: "active",
          title: this.$t("dexAssessment.statusDisputeApproved")
        };
        break;
      case "requested":
        text = {
          label: "waiting",
          title: this.$t("dexAssessment.statusDisputeRequested")
        };
        break;
      case "rejected":
        text = {
          label: "inactive",
          title: this.$t("dexAssessment.statusDisputeRejected")
        };
        break;
      default:
        text = { label: "", title: "" };
        break;
    }
    return text;
  }
}
